module.exports = __webpack_public_path__ + "img/rocket.614f4d4e.png";